import { baseApi } from '@shared/api/baseApi.js';

export const deleteCompanyAdmin = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		deleteCompanyAdmin: builder.mutation({
			query: ({ companyId, userId }) => ({
				url: `/v2/companies/${companyId}/companyUsers/${userId}`,
				method: 'DELETE',
			}),
			invalidatesTags: (_result, error, { companyId, userId }) =>
				error
					? []
					: [
							{ type: 'CompanyAdmins', id: companyId },
							{ type: 'Employee', id: userId },
						],
		}),
	}),
});

export const { useDeleteCompanyAdminMutation } = deleteCompanyAdmin;

// DELETE /v2/companies/{companyId}/companyUsers/{userId}
// Auth required.
// Remove companyUser from Company. This will not remove an Employee form the Company but remove
// the rights to manage the Company.
//
// Path Parameters:
//   companyId  required — ID of the company to the companyUser belongs.
//   userId     required — ID of the companyUser to remove rights.
//
// Responses:
//   204  OK
//   300  application/json — In case an additional authentication is needed the user needs to be
//                            redirected to the loginURL. After authentication the user will be
//                            redirected to redirectURL
//     companyUserId  string (uuid)
//     loginURL       string
//   400  Bad request
//   401  Unauthorized
//   404  Not found.
//     {
//       "loginURL": "string",
//       "companyUserId": "123e4567-e89b-12d3-a456-426614174000"
//     }
